import React from 'react';
import "../../../styles/DashboardStyles/DashboardContent/DashboardHome.css"
import { useApplicationCounts } from '../../../hooks/useApplicationCounts';

export default function DashboardHome() {
    const { total, pending, approved, rejected, loading, error } = useApplicationCounts();
 
    // Helper — shows "..." while loading, number when done
    const display = (value: number) => loading ? "..." : value;
 
    if (error) {
        return (
            <div className="dashboardHome">
                <h2 className="title">Dashboard</h2>
                <p className="dashboard-error">⚠ Failed to load data: {error}</p>
            </div>
        );
    }
 
    return (
        <div className="dashboardHome">
            <h2 className="title">Dashboard</h2>
            <aside>
                <div className="card main-card">
                    <h4>Total Applications</h4>
                    <p className="count">{display(total)}</p>
                    <span className="card-icon">📄</span>
                </div>
                <div className="card">
                    <h4>Pending Applications</h4>
                    <p className="count">{display(pending)}</p>
                    <span className="card-icon">⏳</span>
                </div>
                <div className="card">
                    <h4>Approved Applications</h4>
                    <p className="count">{display(approved)}</p>
                    <span className="card-icon">✅</span>
                </div>
                <div className="card">
                    <h4>Rejected Applications</h4>
                    <p className="count">{display(rejected)}</p>
                    <span className="card-icon">❌</span>
                </div>
            </aside>
        </div>
    );
}